import type { JSX } from 'react';
import { BriefcaseIcon, MoneyBillWaveIcon } from '@c2fo/liquidity/icons';
import globe from '@/enterprise/assets/globe.svg?url';
import { ELIGIBILITY_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';

const CRITERIA_ICONS: JSX.Element[] = [
  <img key="globe" src={globe} alt="" className="h-9 w-9 object-contain" />,
  <BriefcaseIcon key="briefcase" className="h-9 w-9 fill-text-secondary" aria-hidden />,
  <MoneyBillWaveIcon key="money-bill" className="h-9 w-9 fill-text-secondary" aria-hidden />,
];

const EligibilityCriteria = (): JSX.Element => (
  <div className="space-y-6">
    <div className="space-y-4 text-center">
      <p className="text-3xl">{ELIGIBILITY_CONTENT.title}</p>
      <p className="mx-auto max-w-6xl text-lg">{ELIGIBILITY_CONTENT.intro}</p>
    </div>

    <div className="space-y-6 rounded-xl bg-white p-6 shadow-sm">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {ELIGIBILITY_CONTENT.criteria.map((criterion, index) => (
          <div
            key={criterion.title}
            className="flex flex-col items-center justify-center space-y-2 rounded-lg bg-gray-50 p-4 text-center"
          >
            {CRITERIA_ICONS[index]}
            <p className="text-lg font-semibold">{criterion.title}</p>
            <p className="text-base text-text-secondary">{criterion.description}</p>
          </div>
        ))}
      </div>

      <p className="text-center text-xs italic text-text-secondary">{ELIGIBILITY_CONTENT.disclaimer}</p>
    </div>
  </div>
);

export default EligibilityCriteria;
